<template>
    <div class="statistic-dashboard-deposit">
        <div class="statisitc-dashboard-filter">
            <el-date-picker
                v-model="daterange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="to"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                ref="picker"
                :picker-options="pickerOptions"
            ></el-date-picker>
        </div>
        <el-card class="statistic-card" v-for="group in groups" :key="group.asset_name">
            <div slot="header" class="clearfix">
                <span>{{group.asset_name}}</span>
            </div>
            <div class="statistic-card-body">
                <div class="statistic-card-item" v-for="item in group.data" :key="item.status">
                    <h3>{{item.status}}</h3>
                    <div class="statistic-card-item-data">
                        <div class="value">{{item.count}}</div>
                        <div class="title">Count</div>
                    </div>
                    <div class="statistic-card-item-data" v-if="(item.status == 'PENDING' || item.status == 'CANCELLED') && item.total_amount">
                        <div class="value">{{item.total_amount}}</div>
                        <div class="title">Total Amount</div>
                    </div>
                    <div class="statistic-card-item-data" v-if="item.status == 'COMPLETED' && item.total_amount">
                        <div class="value">{{item.total_amount}}</div>
                        <div class="title">Total Amount</div>
                    </div>
                    
                    
                    <div class="statistic-card-item-data" v-if="item.status == 'REFUND' && item.total_confirmed_amount">
                        <div class="value">{{item.total_confirmed_amount}}</div>
                        <div class="title">Total Confirmed Amount</div>
                    </div>
                    <div class="statistic-card-item-data" v-if="(item.status == 'COMPLETED' || item.status == 'REFUND') && item.total_fee">
                        <div class="value">{{item.total_fee}}</div>
                        <div class="title">Total Fee Amount</div>
                    </div>
                    <div class="statistic-card-item-data" v-if="(item.status == 'COMPLETED' || item.status == 'REFUND') && item.total_cost">
                        <div class="value">{{item.total_cost}}</div>
                        <div class="title">Total Cost</div>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
    name: "StatisticDashboardWithdraw",
    components: {},
    data() {
        return {
            daterange: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "1 week",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "1 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "3 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            data: [],
            withdraw: [],
            processing: false
        };
    },
    mounted() {
        let end = new Date();
        let start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.daterange = [start, end]
        this.$refs.picker.$emit('pick', [start, end]);
        this.loadData();
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms
        }),
        groups(){
            let groups = [];
            for(let item of this.data) {
                let group_idx = groups.findIndex(g => { return g.asset_name == item.asset_name; })
                if( group_idx < 0) {
                    groups.push({
                        asset_name: item.asset_name,
                        data: [item]
                    })
                }
                else{
                    groups[group_idx].data.push(item);
                }
            }
            return groups;
        },
        startDate() {
            if(this.daterange && this.daterange[0]) {
                return moment(this.daterange[0]).format('YYYY-MM-DD 00:00:00');
            }
            return null
        },
        endDate() {
            if(this.daterange && this.daterange.length > 1 && this.daterange[1]) {
                return moment(this.daterange[1]).add(1, 'days').format('YYYY-MM-DD 00:00:00');
            }
            return null
        }
    },
    watch: {
        daterange() {
            this.loadData();
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData() {
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = `statistic/withdraw`;
            let params = {};
            let where1 = ""
            let where2 = ""

            if(ctrl.startDate) {
                where1 += ` created >= '${ctrl.startDate}' `
                where2 += ` updated >= '${ctrl.startDate}' `
            }
            if(ctrl.endDate) {
                if(where1.length > 0) { where1 += ` AND ` }
                where1 += ` created <= '${ctrl.endDate}' `
                if(where2.length > 0) { where2 += ` AND ` }
                where2 += ` updated <= '${ctrl.endDate}' `
            }

            params = { where: `(${where1}) OR (${where2})` }

            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    ctrl.data = data;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "STATISTIC_ERROR",
                        message: "Load Statistical Data Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>
<style scoped>
</style>
<style>
</style>